import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { GLOBAL } from "./GLOBAL";
import { HttpClient,HttpHeaders, HttpParams } from "@angular/common/http";
import { FileItem } from '../models/file-item';
import { FirebaseService } from './firebase.service';
import { EventColor } from 'calendar-utils';
@Injectable({
  providedIn: 'root'
})
export class AgendaService {

  public url;

  constructor(
    private _http : HttpClient,
    private _fb: FirebaseService
  ) { 
    this.url = GLOBAL.url;
  }

        //Agendamiento

        // Create a new post reference with an auto-generated id

        registrarCita(title : string, start : Date, end : Date, color : EventColor){
           let postListRef = this._fb.RTDB.ref('agenda');
           let newPostRef = postListRef.push();
            newPostRef.set({
              title,
              start,
              end,
              color
            });
        }

         consultarCitas() {

        let starCountRef =  this._fb.RTDB.ref('agenda');
        starCountRef.on('value', (snapshot) => {
          const data = snapshot.val();
          console.log(data)
          return data;
        });
      }
        
      

    
     /* private registrarFacturaDB(factura: {cliente: string, fecha: any, url: string, valor:number}){
      this._fb.db.collection("facturas").add(factura)
       }


      consultar_pagos(usuario: any):Promise<any>
      {
    
        let pagosRef = this._fb.db.collection("pagos");
        let query = pagosRef.where("cliente", "==", usuario).orderBy("fecha","desc")
        .get()
        return query
      }

*/
   

}
